/* ez-pill-spy.js — section-aware pill nav (scroll-spy). For a sticky ez-pill-nav whose pills are
   in-page anchors (#section), it highlights the pill of the section currently in view as you scroll,
   and lights a pill immediately on click. The active class (.is-active) is already styled by the
   section; this only toggles it. Fully defensive: no-ops if a nav has fewer than 2 resolvable
   #anchor pills. Loaded only where such pills exist (see ez-pill-nav.liquid). */
(function () {
  'use strict';

  function initNav(section) {
    var pills = [].slice.call(section.querySelectorAll('.ez-pn__pill'));
    var items = [];
    pills.forEach(function (p) {
      var href = p.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var el = document.getElementById(href.slice(1));
      if (el) items.push({ pill: p, el: el });
    });
    if (items.length < 2) return;

    // Keep spy order = document order of the targets (a per-question anchor like
    // #international-shipping sits inside its section, so it correctly activates after #ordering).
    items.sort(function (a, b) {
      return a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top;
    });

    // Each target's detection threshold = its OWN scroll-margin-top — the exact spot a jump lands it
    // (e.g. 176px on the FAQ, 140 on videos). Keying the spy to that keeps click + scroll-spy in
    // agreement (a section becomes active the moment its anchor reaches where a click would park it),
    // instead of using the nav's bottom, which sits above the landing point and lags a click.
    items.forEach(function (it) {
      it.sm = parseInt(getComputedStyle(it.el).scrollMarginTop, 10) || 140;
    });

    // On mobile the 6-pill row is a horizontal scroll strip; when the active pill scrolls out of it
    // (e.g. Warranty, the last pill), bring it back into view so the active state is actually visible.
    // No-ops on desktop, where the row wraps and never overflows.
    function ensureVisible(pill) {
      var row = pill.closest ? pill.closest('.ez-pn__row') : null;
      if (!row || row.scrollWidth <= row.clientWidth + 2) return;
      var pr = pill.getBoundingClientRect(), rr = row.getBoundingClientRect();
      var delta = 0;
      if (pr.left < rr.left + 8) delta = pr.left - rr.left - 12;
      else if (pr.right > rr.right - 8) delta = pr.right - rr.right + 12;
      if (!delta) return;
      if (row.scrollTo) row.scrollTo({ left: row.scrollLeft + delta, behavior: 'smooth' });
      else row.scrollLeft += delta;
    }

    var currentActive = null;
    function setActive(active) {
      if (active === currentActive) return;
      currentActive = active;
      items.forEach(function (it) {
        var on = it === active;
        it.pill.classList.toggle('is-active', on);
        if (on) it.pill.setAttribute('aria-current', 'true');
        else it.pill.removeAttribute('aria-current');
      });
      ensureVisible(active.pill);
    }

    // When a pill is clicked the page smooth-scrolls to it; suppress the spy briefly so the clicked
    // pill stays lit through the animation instead of flickering as the scroll passes intermediate
    // sections. The spy resumes after and confirms (the anchor has landed on the clicked section).
    var lockUntil = 0;
    var ticking = false;
    function spy() {
      ticking = false;
      if (Date.now() < lockUntil) return;
      var current = items[0];
      for (var i = 0; i < items.length; i++) {
        // "reached" once the anchor's top is at/above its own landing line (scroll-margin + a hair)
        if (items[i].el.getBoundingClientRect().top - (items[i].sm + 4) <= 1) current = items[i];
        else break;
      }
      setActive(current);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(spy); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Click: light the target pill immediately and hold it through the smooth-scroll.
    items.forEach(function (it) {
      it.pill.addEventListener('click', function () { setActive(it); lockUntil = Date.now() + 900; });
    });

    spy();
  }

  function init() {
    [].slice.call(document.querySelectorAll('.ez-section--pill-nav')).forEach(initNav);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
